import {
  buildDefaultLocalMapTranslationKey,
  IBuildType,
  IShow,
  LocalMapType,
} from "@evennt-tech/api-v2-core";
import { UseTranslateResult } from "@tolgee/react";
import { ENV_KEY_PREFIX } from "tools/localization/envKeyPrefix";

const localizeStand = (
  show: Pick<IShow, "localMap"> | null | undefined,
  buildType: Pick<IBuildType, "standLocalMap"> | undefined,
  t: UseTranslateResult["t"]
) => {
  const translationKey =
    buildType?.standLocalMap?.translationKey ||
    show?.localMap?.standLocalMap?.translationKey ||
    buildDefaultLocalMapTranslationKey(ENV_KEY_PREFIX, LocalMapType.Stand);

  return t(translationKey, { count: 1 });
};

export default localizeStand;
